<template>
    <component :is="typeComponent" :disabled="(busy || disabled)" v-bind="$attrs">
        <span v-if="busy">
            <b-spinner class="mr-2" small/>
        </span>
        <slot v-else name="icon">
            <i v-if="icon" v-bind:class="[icon, 'fal fa-lg fa-inline']"></i>
        </slot>
        <slot></slot>
    </component>
</template>

<script>
    export default {
        name: "loading-button",
        inheritAttrs: false,
        props: {
            busy: {type: Boolean, default: false},
            disabled: {type: Boolean},
            asLink : {type: Boolean},
            icon: {type: String}
        },
        computed: {
            typeComponent() {
                return this.asLink ? 'b-link' : 'b-button';
            },
        }
    }
</script>